'use client'
import { createSlice } from '@reduxjs/toolkit'
import { InitialStateReport } from '@school/common/common-utils/component/AgGridTable/type'
// import { CourseSliceState } from "../types/slices/courseSliceState"
// import { CLASS_MODE_DROPDOWN_LIST } from "../constants/course-constants"
const INITIAL_STATE: InitialStateReport = {
  topics: {},
  reportList: [],
  phaseViewList: [],
  courseOptionList: {
    class: [],
    subject: [],
    center_stream: [],
    class_mode: [],
  },
  appliedFilters: {},
  filters: {},
  addSyllabusCourseIdTo: '',
  addSyllabusCourseIdFrom: '',
  contentDeleteMaterialList: [],
  publishDate: {},
  totalCount: 0,
  assignmentList: [],
  filtersApplied: {},
  reportConfigByName: [],
  storedFilters: [],
  currentAcademicSession: '2025-2026',
}

const reportSlice = createSlice({
  name: 'report',
  initialState: INITIAL_STATE,
  reducers: {
    resetReportListState: () => INITIAL_STATE,
    setAddSyllabusCourseIdTo(state, action) {
      state.addSyllabusCourseIdTo = action.payload
    },
    setFilters(state, action) {
      const { key, val } = action.payload
      state.filters = {
        ...state.filters,
        [key]: val,
      }
    },
    setAllFilterApplied(state, action) {
      state.filtersApplied = action.payload
    },
    clearAllFilters(state) {
      state.appliedFilters = {}
      state.filters = {}
    },
    setAcademicSession(state, action) {
      state.currentAcademicSession = action.payload
    },
    clearFilters(state, action) {
      if (!action.payload) {
        state.filters = []
      } else {
        const filters = state.appliedFilters
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete filters[action.payload]
        state.filters = filters
        state.appliedFilters = filters
      }
    },
    setAllAppliedFilters(state, action) {
      state.appliedFilters = action.payload
    },
    setAppliedFilters(state, action) {
      const { key, value } = action.payload
      state.appliedFilters[key] = value
    },

    setReportList(state, action) {
      state.reportList = action.payload
    },
    setPhaseViewList(state, action) {
      state.phaseViewList = action.payload
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload
    },
    setAssignmentList(state, action) {
      state.assignmentList = action.payload
    },
    resetPublishDate(state) {
      state.publishDate = {}
    },

    removePhaseFromList(state, action) {
      state.assignmentList = state.assignmentList.filter((id) => id !== action.payload)
    },
    setContentDeleteMaterialList(state, action) {
      state.contentDeleteMaterialList = action.payload
    },
    setTopicsByKey(state, action) {
      const { key, value } = action.payload
      state.topics = {
        ...state.topics,
        [key]: value,
      }
    },
    setAddSyllabusCourseIdFrom(state, action) {
      state.addSyllabusCourseIdFrom = action.payload
    },
    setReportConfigByName(state, action) {
      state.reportConfigByName = action.payload // Update the state with the report config
    },
    setStoredFilters(state, action) {
      state.storedFilters = action.payload || []
    },
  },
})
export const {
  setReportList,
  setPhaseViewList,
  setAppliedFilters,
  setAllAppliedFilters,
  clearFilters,
  clearAllFilters,
  setFilters,
  setAddSyllabusCourseIdTo,
  setTotalCount,
  resetReportListState,
  setAssignmentList,
  setAllFilterApplied,
  removePhaseFromList,
  resetPublishDate,
  setContentDeleteMaterialList,
  setTopicsByKey,
  setAddSyllabusCourseIdFrom,
  setReportConfigByName,
  setStoredFilters,
  setAcademicSession,
} = reportSlice.actions

export default reportSlice
